import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Select from "react-select";
import AssetServices from "../../../services/AssetServices";
import Pagination from "../Pagenation/Pagenation";
import Loader from "../Loader/loader";

const AssetList = () => {
  const [stores, setStores] = useState([]);
  const [selectedStore, setSelectedStore] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [sort, setSort] = useState(50); // rows per page
  const [activePage, setActivePage] = useState(0);
  const [test, setTest] = useState(0);
  const [storeSortOrder, setStoreSortOrder] = useState(null);
  const [assetStoreFilter, setAssetStoreFilter] = useState(null);

  // SuperAdmin: stores present in the loaded asset data.
  // Other roles: assigned stores.
  const storeOptions = (
    userRole === "superAdmin"
      ? Array.from(
        new Map(
          data
            .filter((item) => item?.store?._id)
            .map((item) => [item.store._id, item.store])
        ).values()
      )
      : stores
  )
    .map((store) => ({
      value: store._id,
      label: store.name,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

  const options = [
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];



  // Load stores and role
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("userDetails"));
    const availableStores = user?.data?.user?.store || [];
    const role = user?.data?.user?.role || "user";
    setStores(availableStores);
    setUserRole(role);
    if (role !== "superAdmin" && availableStores.length > 0) {
      setSelectedStore(availableStores[0]);
    }
  }, []);

  // Fetch assets
  useEffect(() => {
    const fetchAssets = async () => {
      try {
        setLoading(true);
        let response;
        if (userRole === "superAdmin") {
          response = await AssetServices.getAssetsByStore();
        } else if (selectedStore?._id) {
          response = await AssetServices.getAssetsByStore(selectedStore._id);
        } else {
          setData([]);
          setFilteredData([]);
          setLoading(false);
          return;
        }

        const assets = response?.data?.assets || [];
        setData(assets);
        setFilteredData(assets);
      } catch (err) {
        console.error("Error fetching assets:", err);
        setError("There is some problem in fetching data!");
      } finally {
        setLoading(false);
      }
    };

    fetchAssets();
  }, [selectedStore, userRole, test]);

  // Search, store filter and store sorting
  useEffect(() => {
    const search = searchTerm.trim().toLowerCase();

    const filtered = data.filter((item) => {
      const matchesStore =
        userRole !== "superAdmin" ||
        !assetStoreFilter ||
        item?.store?._id === assetStoreFilter.value;

      const matchesSearch =
        !search ||
        [
          item?.masterItem?.partNo,
          item?.masterItem?.description,
          item?.serialNumber,
          item?.vendor,
          item?.store?.name,
          item?.equipmentNo,
        ].some((value) =>
          String(value || "").toLowerCase().includes(search)
        );

      return matchesStore && matchesSearch;
    });

    if (storeSortOrder) {
      filtered.sort((a, b) => {
        const storeA = (a?.store?.name || "").toLowerCase();
        const storeB = (b?.store?.name || "").toLowerCase();

        return storeSortOrder === "asc"
          ? storeA.localeCompare(storeB)
          : storeB.localeCompare(storeA);
      });
    }

    setFilteredData(filtered);
  }, [searchTerm, data, assetStoreFilter, userRole, storeSortOrder]);

  useEffect(() => {
    setActivePage(0);
  }, [filteredData, selectedStore]);

  // Pagination
  const totalPages = Math.ceil(filteredData.length / sort);

  const handlePageChange = (page) => {
    setActivePage(page);
  };

  const handleSelectChange = (selectedOption) => {
    setSort(selectedOption.value);
    setActivePage(0);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleDateString("en-GB");
  };

  const handleStoreSort = () => {
    setStoreSortOrder((previous) =>
      previous === "asc" ? "desc" : "asc"
    );
  };

  return (
    <>
      <div className="row">
        {loading ? (
          <Loader />
        ) : (
          <div className="col-xl-12">
            {/* Filter Section */}
            <div className="filter cm-content-box box-primary">
              <div className="content-title">
                <div className="cpa">
                  <i className="fas fa-filter me-2"></i>Filter
                </div>
                <div className="tools">
                  <Link
                    to="#"
                    className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                    onClick={() => setOpen(!open)}
                  >
                    <i className="fas fa-angle-up"></i>
                  </Link>
                </div>
              </div>
              <Collapse in={open}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body">
                    <div className="row g-3 align-items-end">
                      <div className="col-md-6 col-xl-4">
                        <label htmlFor="asset-search" className="fw-semibold mb-1">
                          Search
                        </label>
                        <input
                          id="asset-search"
                          type="text"
                          className="form-control"
                          placeholder="Search by Part No, Description, Equipment No, Serial, Vendor or Store"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                      </div>

                      <div className="col-md-6 col-xl-4">
                        <label
                          htmlFor="asset-store-filter"
                          className="fw-semibold mb-1"
                        >
                          Store
                        </label>
                        <Select
                          inputId="asset-store-filter"
                          options={storeOptions}
                          value={
                            userRole === "superAdmin"
                              ? assetStoreFilter
                              : storeOptions.find(
                                (option) => option.value === selectedStore?._id
                              ) || null
                          }
                          onChange={(option) => {
                            setActivePage(0);

                            if (userRole === "superAdmin") {
                              setAssetStoreFilter(option);
                            } else {
                              setSelectedStore(
                                stores.find(
                                  (store) => store._id === option?.value
                                ) || null
                              );
                            }
                          }}
                          placeholder={
                            userRole === "superAdmin"
                              ? "All Stores"
                              : "Select Store"
                          }
                          isSearchable
                          isClearable={userRole === "superAdmin"}
                          className="custom-react-select"
                          noOptionsMessage={() => "No stores available"}
                        />
                      </div>

                      <div className="col-md-6 col-xl-4">
                        <label
                          htmlFor="asset-rows"
                          className="fw-semibold mb-1"
                        >
                          Rows per page
                        </label>
                        <Select
                          inputId="asset-rows"
                          placeholder="Select rows"
                          value={options.find((option) => option.value === sort)}
                          onChange={handleSelectChange}
                          isSearchable={false}
                          options={options}
                          className="custom-react-select"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>

            {/* Asset List Table */}
            <div className="filter cm-content-box box-primary">
              <div className="content-title">
                <div className="cpa">
                  <i className="fa fa-list me-2"></i>Asset List
                  <span className="badge bg-orange ms-2">{filteredData.length}</span>
                </div>
                <div className="tools">
                  <Link
                    to="#"
                    className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                    onClick={() => setOpen2(!open2)}
                  >
                    <i className="fas fa-angle-up"></i>
                  </Link>
                </div>
              </div>
              <Collapse in={open2}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body">
                    <div className="table-responsive">
                      <div
                        id="content_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <div
                          className="scrolltable"
                        >
                          <table
                            className="table table-bordered table-responsive-lg table-striped table-condensed flip-content"
                            id="transactions-data"
                          >
                            <thead className="sticky-table-header">
                              <tr>
                                <th>S.No</th>
                                <th>Inventory Details</th>
                                <th>Asset Details</th>
                                <th>Category</th>

                                <th
                                  style={{ cursor: "pointer" }}
                                  onClick={handleStoreSort}
                                >
                                  Store{" "}
                                  {storeSortOrder === "asc" ? (
                                    <i className="fas fa-arrow-up ms-1 text-primary"></i>
                                  ) : storeSortOrder === "desc" ? (
                                    <i className="fas fa-arrow-down ms-1 text-primary"></i>
                                  ) : (
                                    <i className="fas fa-sort ms-1 text-muted"></i>
                                  )}
                                </th>

                                <th>Additional Details</th>
                              </tr>
                            </thead>
                            <tbody>
                              {filteredData.length > 0 ? (
                                filteredData
                                  .slice(activePage * sort, (activePage + 1) * sort)
                                  .map((item, index) => (
                                    <tr key={item._id}>
                                      <td>{activePage * sort + index + 1}</td>

                                      <td className="text-wrap">
                                        <div className="mb-2">
                                          <strong>Part No:</strong>{" "}
                                          {item?.masterItem?.partNo || "-"}
                                        </div>

                                        <div>
                                          <strong>Description:</strong>{" "}
                                          {item?.masterItem?.description || "-"}
                                        </div>
                                      </td>

                                      <td className="text-wrap">
                                        <div className="mb-2">
                                          <strong>Equipment No:</strong>{" "}
                                          {item?.equipmentNo || "-"}
                                        </div>

                                        <div className="mb-2">
                                          <strong>Vendor:</strong>{" "}
                                          {item?.vendor || "-"}
                                        </div>

                                        <div className="mb-2">
                                          <strong>Serial Number:</strong>{" "}
                                          {item?.serialNumber || "-"}
                                        </div>

                                        <div>
                                          <strong>Model:</strong>{" "}
                                          {item?.model || "-"}
                                        </div>
                                      </td>

                                      <td>{item?.masterItem?.category?.name || "-"}</td>

                                      <td className="scrollable-description">
                                        {item?.store?.name || "-"}
                                      </td>

                                      <td className="text-wrap">
                                        {userRole === "superAdmin" && (
                                          <div className="mb-2">
                                            <strong>Purchased Amount:</strong>{" "}
                                            {item?.purchasedAmount != null
                                              ? Number(item.purchasedAmount).toLocaleString(
                                                "en-IN",
                                                {
                                                  style: "currency",
                                                  currency: "INR",
                                                  minimumFractionDigits: 2,
                                                }
                                              )
                                              : "-"}
                                          </div>
                                        )}

                                        <div className="mb-2">
                                          <strong>Condition:</strong>{" "}
                                          {item?.condition || "-"}
                                        </div>

                                        <div className="mb-2">
                                          <strong>Status:</strong>{" "}
                                          {item?.status || "-"}
                                        </div>

                                        <div>
                                          <strong>Created At:</strong>{" "}
                                          {formatDate(item?.createdAt)}
                                        </div>
                                      </td>
                                    </tr>
                                  ))
                              ) : (
                                <tr>
                                  <td colSpan={6} className="text-center">
                                    {userRole !== "superAdmin" && !selectedStore
                                      ? "Please select a store to view assets."
                                      : "No records found."}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>

                        {/* Pagination footer same as MasterList */}
                        <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">

                          <div className="dataTables_info">
                            Showing{" "}
                            {filteredData.length > 0
                              ? activePage * sort + 1
                              : 0}{" "}
                            to{" "}
                            {Math.min(
                              filteredData.length,
                              (activePage + 1) * sort
                            )}{" "}
                            of {filteredData.length} entries
                          </div>

                          {totalPages > 0 && (
                            <Pagination
                              activePage={activePage}
                              totalPages={totalPages}
                              onPageChange={handlePageChange}
                            />
                          )}

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default AssetList;
